import React from 'react';
import type { BannerFeatureProps } from './types';
import { AtMobile, FromTablet } from 'common/components/adaptive';
import { BannerFactory } from './components';

export const Banner = (props: BannerFeatureProps) => {
  const { banners, showWithoutErid, pageType, onImpressionContentClick, onImpressionContentView } = props;

  if (!banners) return null;

  const isFromSRP = pageType === 'searchPlacements';

  return (
    <>
      <AtMobile>
        {banners?.mobile && (
          <BannerFactory
            data-qa="mobile-placement-banner"
            bannerContent={banners.mobile.content}
            showWithoutErid={showWithoutErid}
            isFromSRP={isFromSRP}
            onImpressionContentClick={onImpressionContentClick}
            onImpressionContentView={onImpressionContentView}
          />
        )}
      </AtMobile>
      <FromTablet>
        {banners?.web && (
          <BannerFactory
            data-qa="tablet-placement-banner"
            bannerContent={banners.web.content}
            showWithoutErid={showWithoutErid}
            isFromSRP={isFromSRP}
            onImpressionContentClick={onImpressionContentClick}
            onImpressionContentView={onImpressionContentView}
          />
        )}
      </FromTablet>
    </>
  );
};
